// extracted by mini-css-extract-plugin
export default {"Confirmation":"VideoComments_Confirmation__6Gl5k","box":"VideoComments_box__8xdIV","video_box":"VideoComments_video_box__qch7L"};